import { Controller } from "stimulus";
import { initSelect2 } from "../../select2_init";

export default class extends Controller {
  connect() {
    initSelect2('#vehicle_constraints_underwriter_id', { placeholder: "Select underwriters...", multiple: true, allowClear: true, width: "80%" });
  }

  fetchUnderwriterConstraints(event) {
    const vehicleModelId = event.target.dataset.vehicleModelId;
    const selectedUnderwriters = document.querySelector('#vehicle_constraints_underwriter_id').selectedOptions;
    const underwriterConstraintsList = document.querySelector('#underwriter-constraints-list');
    const underwriter_ids = Array.from(selectedUnderwriters).map( option => option.value );
    console.log(vehicleModelId);
    fetch(`/vehicle_model/${vehicleModelId}/underwriter_constraints?underwriter_ids=${JSON.stringify(underwriter_ids)}`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      }
    })
    .then(response => response.json())
    .then(data => {

      underwriterConstraintsList.innerHTML = '';
      Array.from(selectedUnderwriters).forEach(option => {
        const constraint = data.find(constraint => constraint.underwriter_id === option.value);
        if (constraint) {
          underwriterConstraintsList.innerHTML += this.setupConstraintCard(constraint.underwriter_name, constraint.vehicle_constraint_type, constraint.underwriter_id, constraint.vehicle_constraint_id);
        }
        else {
          underwriterConstraintsList.innerHTML += this.setupConstraintCard(option.innerHTML, '', option.value, '');
        }
      });
    })
    .catch(error => {
      console.error('Error fetching underwriter constraints:', error);
    });
  }

  setupConstraintCard(name, value, underwriterID, constraintID) {
    const v = value || ""  // treat null/undefined as empty
    const constraintTypes = JSON.parse(document.querySelector('[data-contraint-types]').dataset.contraintTypes);
    const is = (opt) => (opt === v ? "selected" : "")
    return `<div class="card card-body">
      <div class="d-flex flex-nowrap align-items-center gap-3">
        <h5 class="card-title flex-grow-1">${name}</h5>
        <select class="form-control flex-grow-0 w-auto" name="vehicle_constraint_type" 
                data-action="change->vehicle-model--show#updateConstraintType"
                data-underwriter-id="${underwriterID}"
                data-constraint-id="${constraintID}">
          ${constraintTypes.map(type => `<option value="${type.key}" ${is(type.key)}>${type.value}</option>`).join('')}
        </select>
      </div>
    </div>`
  }

  updateConstraintType(event) {
    const element = event.target;
    const makeid = document.querySelector('[data-vehicle-make-id]').dataset.vehicleMakeId;
    const modelid = document.querySelector('[data-vehicle-model-id]').dataset.vehicleModelId;
    const underwriterid = element.dataset.underwriterId;

    fetch(`/update_underwriter_constraint`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      },
      body: JSON.stringify({
        vehicle_constraint: {
          vehicle_make_id: makeid,
          vehicle_model_id: modelid,
          underwriter_id: underwriterid,
          constraint_type: element.value
        }
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log("status: ",data.success);
    })
    .catch(error => {
      console.error('Error updating constraint type:', error);
    });
  }
}
